class LoadJs {
    static loadedFiles = [];

    /**
     * @param {string} file Path to file
     */
    static load(file) {
        return new Promise((resolve, reject) => {
            if (LoadJs.loadedFiles.includes(file)) {
                resolve();
            };

            try {
                const scriptElem = document.createElement('script');
                scriptElem.async = true;
                scriptElem.src = file;

                scriptElem.addEventListener('load', () => {
                    resolve();
                });

                scriptElem.addEventListener('error', () => {
                    reject({
                        message: 'Failed to load ' + file
                    });
                });

                LoadJs.loadedFiles.push(file);
                document.head.appendChild(scriptElem);
            } catch (err) {
                reject(err);
            };
        });
    }
}

export default LoadJs;
